/* eslint-disable no-template-curly-in-string */
// prettier-ignore
let dictionary = {
  LABEL_MAIL: 'Correo',
  LABEL_PASSWORD: 'Contraseña',
  LABEL_UNKNOWN: 'Desconocido',
  LABEL_MEN: 'Hombres',
  LABEL_WOMEN: 'Mujeres',
  LABEL_MAN: 'Hombre',
  LABEL_WOMAN: 'Mujer',
  LABEL_PATIENT: 'Paciente',
  LABEL_PATIENTS: 'Pacientes',
  LABEL_ACTIVE: 'Activos',
  LABEL_ARCHIVED: 'Archivados',
  LABEL_ACTIVE_PATIENTS: 'Pacientes Activos',
  LABEL_EXPIRED_PATIENTS: 'Suscripción vencida',
  LABEL_ARCHIVED_PATIENTS: 'Pacientes Archivados',
  LABEL_ACTIVE_SUBSCRIPTION: 'Con suscripción',
  LABEL_EXPIRED_SUBSCRIPTION: 'Suscr. vencida',
  LABEL_NO_SUBSCRIPTION: 'Sin suscripción',
  LABEL_BELONGS_TO_FAMILY_GROUP: 'Dependiente (sin suscripción propia)',
  LABEL_SUBSCRIPTION: 'Suscripción',
  LABEL_SUBSCRIPTIONS: 'Suscripciones',
  LABEL_ACTIVE_SUBSCRIPTIONS: 'Suscripciones Activas',
  LABEL_ARCHIVED_SUBSCRIPTIONS: 'Suscripciones Archivadas',
  LABEL_ADMINISTRATOR: 'Administrador',
  LABEL_USER: 'Usuario',
  LABEL_VIEWER: 'Visualizador',
  LABEL_MEDECIN: 'Médico',
  LABEL_SEARCH: 'Buscar',
  LABEL_NAME: 'Nombre',
  LABEL_PHONE: 'Teléfono',
  LABEL_BIRTH_DATE: 'Fecha de nacimiento',
  LABEL_BLOOD_TYPE: 'Tipo de sangre',
  LABEL_LEGAL_REPRESENTATIVE: 'Representante legal',
  LABEL_GENDER: 'Sexo',
  LABEL_RIF: 'R.I.F',
  LABEL_ACTION: 'Acciones',
  LABEL_TOTAL_PATIENTS: 'Total pacientes',
  LABEL_COMMENT: 'Comentario',
  LABEL_DATE_START_CONTRACT: 'Fecha de inicio de contrato',
  LABEL_DATE_VALIDITY_CONTRACT: 'Fecha de validez de contrato',
  LABEL_STATUS: 'Estado',
  LABEL_IDENTITY: 'Cédula',
  LABEL_AGE: 'Edad',
  LABEL_ADDRESS: 'Dirección',
  LABEL_INDIVIDUAL: 'Individual',
  LABEL_FAMILY_GROUP: 'Grupo familiar',
  LABEL_HEAD_FAMILY_GROUP: 'Resp. grupo familiar',
  LABEL_COMPANY: 'Empresa',
  LABEL_MISSING: 'Faltante',
  LABEL_DATE: 'Fecha',
  LABEL_TYPE: 'Tipo',
  LABEL_CURRENCY: 'Divisa',
  LABEL_AMOUNT: 'Monto',
  LABEL_START: 'Inicio',
  LABEL_VALIDITY: 'Validez',
  LABEL_CASH: 'Efectivo',
  LABEL_TRANSFER: 'Transferencia',
  LABEL_MOBILE_PAYMENT: 'Pago móvil',
  LABEL_PATIENT_INDIVIDUAL: 'Paciente',

  BUTTON_SIGNIN: 'Conexión',
  BUTTON_DASHBOARD: 'Resumen',
  BUTTON_PATIENTS: 'Pacientes',
  BUTTON_COMPANIES: 'Empresas',
  BUTTON_SUBSCRIPTIONS: 'Suscripciones',
  BUTTON_PAYMENTS: 'Pagos',
  BUTTON_SPECIALISTS: 'Especialistas',
  BUTTON_VISITS: 'Visitas',
  BUTTON_CANCEL: 'Anular',
  BUTTON_CONFIRM: 'Confirmar',
  BUTTON_CLOSE: 'Cerrar',

  LABEL_TOTAL_PAYMENTS: 'Total pagos',
  LABEL_TOTAL_USD: 'Total USD',
  LABEL_TOTAL_BOL: 'Total BOL',
  LABEL_PAYMENTS_THIS_MONTH: 'Pagos del mes',
  LABEL_TOTAL: 'Total',
  LABEL_ACTIVE_F: 'Activas',
  LABEL_ARCHIVED_F: 'Archivadas',
  LABEL_SUBSCRIPTION_ID: 'Suscripción #',
  LABEL_PATIENT_COMPANY: 'Paciente / Empresa',

  MESSAGE_NO_RESULTS: 'No hay resultados',
  MESSAGE_LAST_PAYMENTS: 'Últimos pagos',
  MESSAGE_HEAD_FAMILY_GROUP: 'Persona encargada del grupo familiar',
  MESSAGE_LOGIN: 'Un plan de salud a tu alcance',
  MESSAGE_NUMBER_TOTAL_OF_PATIENTS: 'Número total de pacientes',
  MESSAGE_NUMBER_ACTIVE_PATIENTS: 'Pacientes actualmente activos',
  MESSAGE_NUMBER_ARCHIVED_PATIENTS: 'Total de pacientes archivados',
  MESSAGE_NUMBER_TOTAL_OF_SUBSCRIPTIONS: 'Número total de suscripciones',
  MESSAGE_NEW_PATIENTS_BY_MONTH: 'Nuevos pacientes por mes',
  MESSAGE_PAYMENTS_BY_MONTH: 'Pagos por mes',
  MESSAGE_DISTRIBUTION_PATIENTS_BY_AGE: 'Distribución por edad de los pacientes',
  MESSAGE_DISTRIBUTION_PATIENTS_BY_GENDER: 'Distribución por género de los pacientes',
  MESSAGE_BIRTHDAYS_PATIENTS: 'Compleaños del mes',
  MESSAGE_NO_BIRTHDAYS_THIS_MONTH: 'No hay cumpleaños este mes',
  MESSAGE_BIRTHDAYS_TODAY: 'Compleaños de hoy',
  MESSAGE_NO_BIRTHDAYS_TODAY: 'No hay cumpleaños hoy',
  MESSAGE_CONFIRM_REMOVE: '¿Estás seguro(a) que quieres eliminar este elemento? Esto no se puede recuperar después.',
  MESSAGE_INTEGRATE_PATIENT_IN_SUBSCRIPTION: 'Una vez creado el paciente, debes incluirlo en la suscripción de empresa o de familia adecuada a través de la página de suscripciones',
  MESSAGE_SUBSCRIPTION_WILL_CREATE_AUTOMATICALLY: 'La suscripción asociada se creará automáticamente',
  MESSAGE_NO_PATIENTS: 'No hay pacientes',
  MESSAGE_NO_PAYMENTS: 'No hay pagos',
  MESSAGE_NO_PAYMENTS_THIS_MONTH: 'No hay pagos este mes',
  MESSAGE_SEARCH_PATIENT_IN_SUSCRIPTION: 'Si buscas un paciente que forma parte de una compañía o un grupo familiar, el sistema te mostrará la compañía o el grupo familiar. Debes hacer clic y verás la lista de pacientes.',
  MESSAGE_HEAD_IS_BOLD: 'La persona encargada del grupo familiar se mostrará en negrita',
  MESSAGE_LIST_SUBSCRIPTIONS: 'Estado de suscripción',
  MESSAGE_PATIENT_ARCHIVED: 'Paciente archivado correctamente',
  MESSAGE_PATIENT_UNARCHIVED: 'Paciente desarchivado correctamente',
  MESSAGE_SUBSCRIPTION_ARCHIVED: 'Suscripción archivada correctamente',
  MESSAGE_SUBSCRIPTION_UNARCHIVED: 'Suscripción desarchivada correctamente',
  MESSAGE_CONFIRM_ARCHIVE_SUBSCRIPTION: '¿Estás seguro(a) que quieres archivar esta suscripción? Todos los pacientes relacionados también serán archivados.',
  MESSAGE_CONFIRM_UNARCHIVE_SUBSCRIPTION: '¿Estás seguro(a) que quieres desarchivar esta suscripción? Todos los pacientes relacionados también serán desarchivados.',

  TITLE_CONFIRM_REMOVE: 'Confirmación de eliminación',
  TITLE_CONFIRM_ARCHIVE: 'Confirmación de archivado',
  TITLE_CONFIRM_UNARCHIVE: 'Confirmación de desarchivado',
  TITLE_PATIENTS_SUBSCRIPTION: 'Pacientes de la suscripción',
  TITLE_PAYMENTS_SUBSCRIPTION: 'Pagos de la suscripción',

  ERROR_USER_NOT_FOUND: 'Usuario no encontrado',
  ERROR_ENTER_MAIL: 'Por favor, indica un correo',
  ERROR_ENTER_DATE_START: 'Por favor, indica la fecha de inicio',
  ERROR_ENTER_PASSWORD: 'Por favor, indica una contraseña',
  ERROR_PATIENT_NUMBER_EXISTS: 'Este número de paciente ${0} ya existe',
  ERROR_COMPANY_NUMBER_EXISTS: 'Este número de empresa ${0} ya existe',
  ERROR_UNKNOWN: 'Ocurrió un error. Si esto persiste, comunícate con el soporte',
  ERROR_ARCHIVE_PATIENT: 'Error al archivar/desarchivar el paciente',
  ERROR_ARCHIVE_SUBSCRIPTION: 'Error al archivar/desarchivar la suscripción',
  ERROR_DATE_OR_AMOUNT: 'Por favor, indica la fecha y el monto',

  LABEL_SPECIALTY: 'Especialidad',
  LABEL_DAY: 'Día',
  LABEL_FROM: 'Desde',
  LABEL_TO: 'Hasta',

  DAY_MONDAY: 'Lunes',
  DAY_TUESDAY: 'Martes',
  DAY_WEDNESDAY: 'Miércoles',
  DAY_THURSDAY: 'Jueves',
  DAY_FRIDAY: 'Viernes',
  DAY_SATURDAY: 'Sábado',
  DAY_SUNDAY: 'Domingo',

  TITLE_AVAILABILITIES: 'Disponibilidades',
  MESSAGE_NO_AVAILABILITIES: 'No hay disponibilidades registradas',

  REQUIREMENT_NAME_COMPANY: 'El nombre de la empresa debe tener entre 4 y 60 caracteres',
  REQUIREMENT_SPECIALTY: 'La especialidad es obligatoria',
  REQUIREMENT_NAME_SPECIALIST: 'El nombre del especialista es obligatorio',
  REQUIREMENT_NAME_PATIENT: 'El nombre del paciente debe tener entre 4 y 60 caracteres',
  REQUIREMENT_ID_PATIENT: 'El número de cédula debe ser del formato V-12345678',
  REQUIREMENT_RIF: 'El RIF debe ser del formato J-12345678 o J-123456789',
  REQUIREMENT_BIRTH_DATE: 'La fecha de nacimiento debe estar en el pasado',
  REQUIREMENT_MINOR: 'El paciente es menor de edad, por favor selecciona al representante legal',
};
export default dictionary;
